// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__2bNAZ","load8":"spinner_load8__1jnCy","loaderLarge":"spinner_loaderLarge__2bsMr","loadingData":"spinner_loadingData__1OQtB"};